export class InventoryTaxSummary {
    /** Total number of all sales associated with this tax summary entry. */
    public count: number = 0

    /** Total Base sale price of all sales associated with this tax summary entry. */
    public price: number = 0

     /** Total Base sale price of all sales associated with this tax summary entry. */
    public tax: number = 0
    
    /** Full name of the entity associated with this tax summary entry. */
    public name: string = ''
    
    /** Street address of the entity associated with this tax summary entry.  */
    public address: string = ''
    
    /** City, state and zip code of the entity associated with this tax summary entry. */
    public cityStateZip: string = ''
    
    /** Unique TX or other state dealer number of the lot associated with this tax summary entry. */
    public dealerNumber: string = ''
    
    /** Unique federal tax identity number of the lot associated with this tax summary entry. */
    public einNumber: string = ''
}
